import Vue from 'vue';
import App from './App.vue';
import InstantSearch from 'vue-instantsearch';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'vue-googlemaps/dist/vue-googlemaps.css';
import './css/animate.css';
import './css/simple-sidebar.css';
import VueGoogleMaps from 'vue-googlemaps';
import VueMoment from 'vue-moment';
import VueScrollTo from 'vue-scrollto';
import VueFilterPluralize from '@vuejs-community/vue-filter-pluralize';
import {
  faBed,
  faBath,
  faCouch,
  faHome,
  faLink,
  faPoundSign,
  faCalendarCheck,
  faMap,
  faSlidersH,
  faSearch,
  faQuestion,
  faTimes,
  faCaretRight,
  faCaretLeft,
  faForward,
  faBackward,
  faCircle,
} from '@fortawesome/free-solid-svg-icons';

Vue.use(VueScrollTo);

Vue.use(VueMoment);

Vue.use(VueFilterPluralize);

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyBjBaKoiUoQSVw4ywZZqmJN0GGPDCk2F98',
  },
});

library.add(
  faBed,
  faBath,
  faCouch,
  faHome,
  faLink,
  faPoundSign,
  faCalendarCheck,
  faMap,
  faSlidersH,
  faSearch,
  faQuestion,
  faTimes,
  faCaretRight,
  faCaretLeft,
  faForward,
  faBackward,
  faCircle
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(InstantSearch);

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  render: (h) => h(App),
});
